import AddLibraryDialog from '@/components/navigation/wizard/library/AddLibraryDialog';
import { useApplication } from '@/hooks/useApplication';
import { useSubroutine } from '@/hooks/useSubroutine';
import { OpenEditType } from '@/types/subroutine';
import { Folder } from '@mui/icons-material';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import { Button, ListItemIcon, Menu, MenuItem } from '@mui/material';
import React, { FC } from 'react';
import { useAuth } from 'react-oidc-context';
import HandleFoldersDialog from './HandleFoldersDialog';
import AuthorizedMenuItem from './menu-items/AuthorizedMenuItem';
import SubroutineNewMenuItem from './menu-items/SubroutineNewMenuItem';

type AddMenuProps = {
  openEdit: (openEdit: OpenEditType) => void;
};

const actions = [
  // { icon: <WebAssetIcon />, name: 'Block' },
  { icon: <MoveDownIcon />, name: 'Subroutine' }
];

const EditMenu: FC<AddMenuProps> = (props) => {
  const auth = useAuth();
  const { application, setApplication } = useApplication();
  const { selectedSubroutineId } = useSubroutine();
  const [openFoldersDialog, setOpenFoldersDialog] = React.useState(false);
  const [openAddLibraryDialog, setOpenAddLibraryDialog] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id='edit-button'
        aria-controls={open ? 'edit-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        disabled={!selectedSubroutineId}
        onClick={handleClick}
        color='inherit'
      >
        Edit
      </Button>
      <Menu
        id='edit-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'edit-button',
          sx: { minWidth: '10rem' }
        }}
      >
        <SubroutineNewMenuItem openEdit={props.openEdit} onClose={handleClose} />
        <MenuItem
          onClick={() => {
            setOpenFoldersDialog(true);
            handleClose();
          }}
        >
          <ListItemIcon>
            <Folder fontSize='small' />
          </ListItemIcon>
          Add folder
        </MenuItem>
        <AuthorizedMenuItem
          onClick={() => {
            auth.isAuthenticated && setOpenAddLibraryDialog(true);
            handleClose();
          }}
        >
          <ListItemIcon>
            <LibraryAddIcon fontSize='small' />
          </ListItemIcon>
          Add library
        </AuthorizedMenuItem>
      </Menu>
      <HandleFoldersDialog
        open={openFoldersDialog}
        folders={application.folders}
        application={application}
        setApplication={setApplication}
        onClose={() => setOpenFoldersDialog(false)}
      />
      <AddLibraryDialog open={openAddLibraryDialog} onClose={() => setOpenAddLibraryDialog(false)} />
    </div>
  );
};

export default EditMenu;
